import React from 'react'
import { Box, Typography } from '@mui/material'
import theme from '../theme'

interface Props {
  label: string
  value: string | number | React.ReactNode
  color?: string
  flex?: number
  icon?: React.ReactNode
  labelAction?: React.ReactNode
}

const InfoDisplay = ({
  label,
  value,
  color = theme.palette['base-black'],
  flex = 1,
  icon,
  labelAction
}: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.space['8'],
        flex: flex,
        minWidth: '200px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.space['8'] }}>
        <Typography
          variant="body-11"
          sx={{
            color: theme.palette['sage-400'],
            textWrap: 'nowrap'
          }}
        >
          {label}
        </Typography>
        {labelAction}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        {icon && (
          <Box
            sx={{
              marginRight: theme.space['12']
            }}
          >
            {icon}
          </Box>
        )}
        <Typography variant="body-12" sx={{ color }}>
          {value}
        </Typography>
      </Box>
    </Box>
  )
}

export default InfoDisplay
